import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Meta } from '@df/core/meta/meta';
import { ISizeName } from '@df/core/service/client';
import { BodyClassService } from '@df/ui/body-class.service';
import { DfModal } from '@df/ui/modal/df-modal.decorator';
import { NDfModal } from '@df/ui/modal/df-modal.interface';
import { ModalRef } from '@df/ui/modal/modal-ref';
import { MODAL_DATA } from '@df/ui/modal/modal.service';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { UiComponent } from '@df/ui/ui.component';
import { NICmsContentComponent } from '@icms/core/content';

export namespace NVipRestrictedContentModal {
    export const BLOCK_ID = 'vip-restricted-modal';

    export interface IModalData {
        restrictionType?: 'customer_group' | 'other';
    }
}

@DfModal({
    id: NVipRestrictedContentModal.BLOCK_ID,
    position: (sizeId: ISizeName) => (sizeId === 'S' ? 'bottom' : undefined),
    config: (sizeId: ISizeName) => ({
        closeOnNavigation: true,
        maxWidth: sizeId === 'S' || sizeId === 'M' ? '91vw' : '455px',
        width: sizeId === 'S' || sizeId === 'M' ? '343px' : '455px',
        disableClose: true
    }),
    blockGroup: 'modals',
    priority: 20,
    reopenPolicy: NDfModal.ReopenPolicy.first,
    sizeRestriction: sizeName => ({ S: ['S', 'M'], M: ['S', 'M'], L: ['L', 'X'], X: ['L', 'X'] })[sizeName]
})
@Component({
    selector: 'vip-restricted-modal',
    templateUrl: './vip-restricted-modal.html',
    standalone: true,
    imports: [TranslationModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class VipRestrictedModalComponent extends UiComponent implements NICmsContentComponent.IComponent, OnInit {
    protected isCustomerGroupRestriction = false;

    constructor(
        private meta: Meta,
        private bodyClassService: BodyClassService,
        private router: Router,
        private modalRef: ModalRef<any>,
        @Inject(MODAL_DATA) private data?: NVipRestrictedContentModal.IModalData
    ) {
        super();
        this.isCustomerGroupRestriction = this.data?.restrictionType === 'customer_group';
    }

    override ngOnInit(): void {
        if (!this.isCustomerGroupRestriction) {
            this.bodyClassService.add('full-overlay', this);
        }
        super.ngOnInit();
    }

    override ngOnDestroy(): void {
        if (!this.isCustomerGroupRestriction) {
            this.bodyClassService.remove('full-overlay', this);
        }
        super.ngOnDestroy();
    }

    protected goBack(): void {
        this.router.navigate(['/']);
    }

    protected close(): void {
        this.modalRef.close();
    }
}
